// src/utils/decorators/decorateComms.js

export function decorateComms(comm) {
  const todayIso = new Date().toISOString();

  return {
    resourceType: "Communication",
    id: comm.id || "unknown",
    status: comm.status || "unknown",
    sent: comm.sent || todayIso,
    priority: comm.priority || "unknown",
    topic: comm.topic || "unknown",

    category: Array.isArray(comm.category) && comm.category.length > 0
      ? comm.category
      : [{ coding: [{ display: "unknown" }] }],

    encounter: comm.encounter?.reference
      ? { reference: comm.encounter.reference }
      : { reference: "unknown" },

    extension: Array.isArray(comm.extension) && comm.extension.length > 0
      ? comm.extension
      : [{ url: "unknown", extension: [] }],

    inResponseTo: Array.isArray(comm.inResponseTo) && comm.inResponseTo.length > 0
      ? comm.inResponseTo
      : [{ reference: "unknown" }],

    partOf: Array.isArray(comm.partOf) && comm.partOf.length > 0
      ? comm.partOf
      : [{ reference: "unknown" }],

    payload: Array.isArray(comm.payload) && comm.payload.length > 0
      ? comm.payload
      : [{ contentString: "unknown" }],

    recipient: Array.isArray(comm.recipient) && comm.recipient.length > 0
      ? comm.recipient
      : [{ reference: "unknown" }],

    sender: comm.sender?.reference
      ? { reference: comm.sender.reference }
      : { reference: "unknown" },

    subject: comm.subject?.reference
      ? { reference: comm.subject.reference }
      : { reference: "unknown" },

    meta: {
      lastUpdated: comm.meta?.lastUpdated || "unknown",
      versionId: comm.meta?.versionId || "unknown"
    }
  };
}